/**
 * Annual `chat_tokens` limits by tier, in tokens. Source of truth for the
 * numbers.
 *
 * `unlimited` is a very large finite number rather than `Infinity` so it
 * round-trips cleanly through the numeric limit comparisons and the
 * admin-panel display without special-casing. ~9e15 (Number.MAX_SAFE_INTEGER)
 * is astronomically beyond any real annual chat consumption.
 *
 * NOTE: do not surface the Starter (3M) number to customers anywhere —
 * the at-limit UX shows a generic message, never the figure.
 */
export const CHAT_TOKEN_LIMITS = {
  enterprise: 100_000_000,
  pro: 20_000_000,
  starter: 3_000_000,
  unlimited: Number.MAX_SAFE_INTEGER,
} as const;

/**
 * Annual connector tool-call caps by tier. Keys line up with `CHAT_TOKEN_LIMITS`
 * so a resolved tier maps directly.
 *
 * `unlimited` is a very large finite number rather than `Infinity` so it
 * round-trips through the numeric limit comparisons and the admin-panel
 * display without special-casing — mirrors `CHAT_TOKEN_LIMITS.unlimited`.
 *
 * NOTE: as with the token tiers, do not surface the Starter figure to
 * customers — the at-limit UX shows a generic message, never the number.
 */
export const CONNECTOR_TOOL_CALL_LIMITS = {
  enterprise: 3_000,
  pro: 600,
  starter: 90,
  unlimited: Number.MAX_SAFE_INTEGER,
} as const;
